module.exports = __webpack_public_path__ + "img/unicorn-book_B0979SH6R3.24b1966b.jpg";